export const useGetStoreLink = (deeplink?: string) => {
  if (deeplink) {
    deeplink = encodeURIComponent(deeplink);
  }
  deeplink = deeplink || "";
  const route = useRoute();
  const query = route.query;

  if (query["referrerId"]) {
    // 초대용 링크
    const referrerId = query["referrerId"] as string;
    const referrerOnelink = useRuntimeConfig().public.REFERRER_ONELINK;
    return `${referrerOnelink}?af_force_deeplink=true&af_dp=${deeplink}&af_sub1=${referrerId}`;
  } else if (decodeURIComponent(route.path).includes("referrerId=")) {
    // 초대용 링크(인코딩 되어있을때)
    const params = new URLSearchParams(
      decodeURIComponent(route.path).split("?")[1]
    );
    const referrerId = params.get("referrerId") as string;
    const referrerOnelink = useRuntimeConfig().public.REFERRER_ONELINK;
    const link = referrerId
      ? `${referrerOnelink}?af_force_deeplink=true&af_sub1=${referrerId}`
      : `${referrerOnelink}?af_force_deeplink=true`;
    return link;
  } else {
    let link = `https://oivivalavida.onelink.me/OHzl/azdc2gq9?af_force_deeplink=true&af_dp=${deeplink}`;
    if (route.query.utm_source === "meta") {
      link = `https://oivivalavida.onelink.me/OHzl/r3ry36j3?af_force_deeplink=true&af_dp=${deeplink}`;
    } else if (route.query.utm_source === "google-ads") {
      link = `https://oivivalavida.onelink.me/6FsO/1oqv8pjt?af_force_deeplink=true&af_dp=${deeplink}`;
    }
    return link;
  }
};
